import { createAsyncAction } from "typesafe-actions";
import { AccountPayload, AccountResponse } from "./../../../services/accounts";

export const createAccountAsync = createAsyncAction(
  "CREATE_ACCOUNT_REQUEST",
  "CREATE_ACCOUNT_SUCCESS",
  "CREATE_ACCOUNT_FAILURE"
)<AccountPayload, AccountResponse, string>();

export const fetchAccountsAsync = createAsyncAction(
  "FETCH_ACCOUNTS_REQUEST",
  "FETCH_ACCOUNTS_SUCCESS",
  "FETCH_ACCOUNTS_FAILURE"
)<undefined, AccountResponse[], string>();
